import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const OfferContainer = styled.div`
  display: flex;
  background-color: #ffffff;
  width: 100%;
  flex-direction: column;
`;

export const OfferInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
    border-bottom: solid 1px #f0f0f0;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 136px;
  padding: 8px;
  min-width: 10%;
  border-bottom: solid 1px #f0f0f0;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    min-width: 204px;
    min-height: 220px;
    border-bottom: 0;
  }
`;

export const ImageElement = styled.img`
  height: 140px;
  width: 140px;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    flex: 1;
  }
`;

export const InfosContainer = styled.div`
  display: flex;
  gap: 8px;
  align-content: start;
  border-bottom: solid 1px #f0f0f0;
  flex-wrap: wrap;
  padding: 8px;
  height: 100%;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 16px;
    gap: 12px;
    border-left: solid 1px #f0f0f0;
    border-bottom: 0;
  }
`;

export const ObsContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
  border-bottom: solid 1px #f0f0f0;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    border-top: solid 1px #f0f0f0;
    border-left: solid 1px #f0f0f0;
    border-bottom: 0;
    padding: 16px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  height: fit-content;
  gap: 2px;

  @media (min-width: ${BREAKPOINTS.phone}) {
    flex-direction: column;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
  }
`;

export const InfoIconContainer = styled.div`
  display: none;
  flex-direction: column;
  justify-content: start;
  color: #f78e1e;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: flex;
  }
`;

export const InfoDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const InfoTitle = styled.h3`
  font-size: 0.625rem;
  font-weight: 400;
  color: #8c8c8c;
  margin-bottom: 2px;
`;

export const InfoValue = styled.h3`
  font-size: 0.75rem;
  font-weight: 400;
  color: black;
  margin-bottom: 0;
  word-break: break-word;
`;

export const Tag = styled(InfoValue)`
  background-color: ${({ children }) =>
    children === 'A1' ? '#389E0D' : '#FADB14'};
  color: white;
  font-weight: 700;
  text-align: center;
  border-radius: 2px;
  width: 17px;
  height: 14px;
`;
